var map = {
	"./Statistics.svg": "29f1",
	"./approval.svg": "804b",
	"./certificate.svg": "0da5",
	"./clock.svg": "9f74",
	"./company.svg": "5cd5",
	"./dashboard.svg": "7154",
	"./data.svg": "80e8",
	"./depart.svg": "5f2c",
	"./download-c.svg": "15bd",
	"./download-cs.svg": "1594",
	"./example.svg": "b6f9",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./group.svg": "76d4",
	"./holiday.svg": "a924",
	"./invite.svg": "8cc9",
	"./logo-close.svg": "79ab",
	"./logo-open.svg": "64b2",
	"./message.svg": "15e8",
	"./money.svg": "4955",
	"./org.svg": "fac9",
	"./payroll-list.svg": "799b",
	"./position.svg": "3358",
	"./power.svg": "456c",
	"./record.svg": "c9d9",
	"./salaryScheme.svg": "8ed8",
	"./setting.svg": "08d1",
	"./sliderbar-close 2.svg": "a55d",
	"./sliderbar-close.svg": "9ad8",
	"./sliderbar-open.svg": "cf37",
	"./staff-info.svg": "c4d3",
	"./staffWage.svg": "3896",
	"./table.svg": "dc78",
	"./tax.svg": "5dca",
	"./tree.svg": "0e8f",
	"./user.svg": "d88a",
	"./wage.svg": "9ba3",
	"./工作台.svg": "2a29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";